module.exports = __webpack_public_path__ + "static/img/MTI-Standard-B-通用型.4e03b311.jpg";